export function applyVanerixBranding(value: string): string {
  return value.replace(/satoshi(?:[- ]bot)?/gi, 'Vanerix');
}
